export const BUSINESS = {
  name: "Orion Services LLC",
  tagline: "Precision Engineered Heavy Duty Automotive, Truck & Tractor Components",
  phone: "+1 208-681-0195",
  phoneRaw: "+12086810195",
  emails: ["hello@orioncustom.com"],
  address: "255 Rivertown Shops Dr, Suite 102-267, Saint Johns, FL 32259",
  logo: "https://customer-assets-4nw71qhi.emergentagent.net/job_b59a6236-b629-4ccc-8b14-cdd611a757a4/artifacts/k37kgm7h_WhatsApp%20Image%202026-08-18%20at%2013.27.14.jpeg",
};

export const CATEGORY_IMAGES = {
  "Engine parts": "https://images.unsplash.com/photo-1523559094051-53bac879eb80?crop=entropy&cs=srgb&fm=jpg&q=85",
  "Brakes": "https://images.unsplash.com/photo-1588017530244-c57df911f73b?crop=entropy&cs=srgb&fm=jpg&q=85",
  "Suspension": "https://images.unsplash.com/photo-1720796112186-91995737c017?crop=entropy&cs=srgb&fm=jpg&q=85",
  "Filters": "https://images.pexels.com/photos/11074558/pexels-photo-11074558.jpeg?auto=compress&cs=tinysrgb&h=650&w=940",
  "Electrical": "https://images.pexels.com/photos/8478245/pexels-photo-8478245.jpeg?auto=compress&cs=tinysrgb&h=650&w=940",
  "Tires & Wheels": "https://images.unsplash.com/photo-1541487880852-afcef8ba6d2c?crop=entropy&cs=srgb&fm=jpg&q=85",
  "Transmission": "https://images.unsplash.com/photo-1704109505135-fa76ea671525?crop=entropy&cs=srgb&fm=jpg&q=85",
  "Hydraulics": "https://images.pexels.com/photos/10912797/pexels-photo-10912797.jpeg?auto=compress&cs=tinysrgb&h=650&w=940",
};

export const CATEGORIES = Object.keys(CATEGORY_IMAGES);

export const MANIFESTO = [
  {
    number: "01",
    title: "FORGED IN STEEL & BRASS",
    subtitle: "No compromised alloys, no fragile tolerances.",
    description: "Every component in the Orion Services catalog is rated for extreme commercial duty cycles. From cross-country interstate freight to deep-field agricultural harvest, our parts undergo rigorous stress verification.",
  },
  {
    number: "02",
    title: "RAPID QUOTE INTAKE & DIRECT DISPATCH",
    subtitle: "Zero-friction procurement built for logistics chiefs.",
    description: "When heavy machinery halts, revenue stops. Our integrated quote engine and live SKU indexing connects your maintenance depot directly with our engineering technicians within hours.",
  },
  {
    number: "03",
    title: "TRANSPARENT INVENTORY & EXACT SKUS",
    subtitle: "Real-time stock indicators without bait-and-switch.",
    description: "Clear stock status badges, immediate lead-time advisories for out-of-stock custom assemblies, and precise cross-compatibility tables for Peterbilt, Freightliner, John Deere, CAT, and Case IH.",
  },
  {
    number: "04",
    title: "FLORIDA ENGINEERING HEADQUARTERS",
    subtitle: "Dedicated human technical support across Saint Johns & beyond.",
    description: "Direct point-of-contact support staffed by automotive and agricultural mechanics. Curt, Eric, and Abhi oversee precision quality assurance for every intake batch.",
  },
];

export const QUOTE_STATUSES = ["new", "quoted", "dispatched", "closed"];

export const CUSTOM_ORDER_STATUSES = ["new", "reviewing", "quoted", "in_production", "completed", "cancelled"];

export const BUDGET_RANGES = ["Under $500", "$500 - $2,000", "$2,000 - $5,000", "$5,000+", "Not sure yet"];

export const CUSTOM_ORDER_PROCESS = [
  { number: "01", title: "Submit Your Design", description: "Share a CAD file, sketch, reference photos, or the worn original part — whatever you have on hand." },
  { number: "02", title: "Engineering Review", description: "Our team reviews specs, dimensions, and material within 1-2 business days and follows up with questions." },
  { number: "03", title: "Prototype & Fit Check", description: "For complex parts, a single prototype ships first for fitment verification before a full production run." },
  { number: "04", title: "Precision Fabrication", description: "CNC machining, precision casting, or fabricated steel assembly — every part is pressure and stress tested before it ships." },
];
